export default {
  TableHeadDownLine: [
    [
      {
        displayName: 'account.downline.number',
      },
      {
        displayName: 'account.downline.type',
      },
      {
        displayName: 'account.downline.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.nickname',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.phone',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.manage',
      },
      {
        displayName: 'account.downline.suspend',
      },
      {
        displayName: 'account.downline.currency',
      },
      {
        displayName: 'account.downline.credit',
        attr: {
          class: 'text-right',
        },
      },
      // {
      //   displayName: 'account.downline.pt',
      // },
      // {
      //   displayName: 'account.downline.currency',
      // },
      // {
      //   displayName: 'account.downline.commission',
      // },
      {
        displayName: 'account.downline.edit_pt',
      },
      {
        displayName: 'account.downline.refill_deduct',
      },
      {
        displayName: 'account.downline.last_login',
      },
      {
        displayName: 'account.downline.last_ip',
      },
      {
        displayName: 'account.downline.report',
      },
    ],
  ],
  TableHeadSubAccount: [
    [
      {
        displayName: 'account.downline.number',
      },
      {
        displayName: 'account.downline.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.nickname',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.phone',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'createAccount.permission_title',
      },
      {
        displayName: 'account.downline.manage',
      },
      {
        displayName: 'account.downline.suspend',
      },
      {
        displayName: 'account.downline.currency',
      },
      {
        displayName: 'account.downline.credit',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'account.downline.refill_deduct',
      },
      {
        displayName: 'account.downline.last_login',
      },
      {
        displayName: 'account.downline.last_ip',
      },
      {
        displayName: 'account.downline.report',
      },
    ],
  ],
  TableHeadDownLineCheckRole: [
    [
      {
        displayName: 'account.downline.number',
      },
      {
        displayName: 'account.downline.type',
      },
      {
        displayName: 'account.downline.username',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.nickname',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.phone',
        attr: {
          class: 'text-left',
        },
      },
      {
        displayName: 'account.downline.suspend',
      },
      {
        displayName: 'account.downline.currency',
      },
      {
        displayName: 'account.downline.credit',
        attr: {
          class: 'text-right',
        },
      },
      {
        displayName: 'account.downline.last_login',
      },
      {
        displayName: 'account.downline.last_ip',
      },
      {
        displayName: 'account.downline.report',
      },
    ],
  ],
  TableHeadTran: [
    [
      {
        displayName: 'multicurrency.no',
      },
      {
        displayName: 'multicurrency.refill',
      },
      {
        displayName: 'multicurrency.deduct',
      },
      {
        displayName: 'multicurrency.currency',
      },
      {
        displayName: 'multicurrency.date',
      },
    ],
  ],
  initialModal() {
    return {
      editInfo: false,
      lock: false,
      password: false,
      pt: false,
      refill: false,
      deduct: false,
      report: false,
      permission: false,
      isFeature: false,
      statusFeature: true,
    };
  },
  initialUserInfo() {
    return {
      name: null,
      nickname: null,
      gender: null,
      mobile: null,
      lineId: null,
      facebook: null,
    };
  },
  initialLock() {
    return {
      activate: null,
      username: null,
    };
  },
  initialPassword() {
    return {
      username: null,
      newPassword: null,
      confirmPassword: null,
    };
  },
  initialPT() {
    return {
      general: 0,
    };
  },
  initialRefill() {
    return {
      type: 'TRANSFER',
      amount: 0,
      username: '',
      currency: '',
    };
  },
  initialDeduct() {
    return {
      type: 'WITHDRAW',
      amount: 0,
      username: '',
      currency: '',
    };
  },
  initialPermission() {
    return {
      isRefillCredit: false,
      isDeductCredit: false,
      fullMemberAccess: false,
      viewMemberAccess: false,
      reportAccess: false,
      reportMechanicAccess: false,
    };
  },
  initialUserPermission() {
    return {
      member: 'off',
      report: 'off',
      seamless: 'off',
      statement: 'off',
      suggestion: 'off',
      useronline: 'off',
      apikey: 'off',
      reportMechanic: 'off',
    };
  },
  initialFeature() {
    return {
      isFeature: true,
    };
  },
};
